var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedoMedium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.41797 14.5C2.41797 14.9142 2.08218 15.25 1.66797 15.25C1.25375 15.25 0.917968 14.9142 0.917968 14.5H2.41797ZM15.668 6.13639L16.2135 5.62166L16.6992 6.13639L16.2135 6.65112L15.668 6.13639ZM15.668 6.9045H6.08902V5.4045H15.668V6.9045ZM2.41797 10.8397V14.5H0.917968V10.8397H2.41797ZM6.08902 6.9045C4.10196 6.9045 2.41797 8.62475 2.41797 10.8397H0.917968C0.917968 7.87952 3.19272 5.4045 6.08902 5.4045V6.9045ZM11.8385 0.985269L16.2135 5.62166L15.1225 6.65112L10.7475 2.01473L11.8385 0.985269ZM16.2135 6.65112L11.8385 11.2875L10.7475 10.258L15.1225 5.62166L16.2135 6.65112Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedoMedium);
export default __webpack_public_path__ + "static/media/redo-medium.9bc63d993471e601970ddf2b639c2199.svg";
export { ForwardRef as ReactComponent };